<template>
    <b-container fluid>
        <div>
            <b-tabs content-class="mt-3">
                <b-tab title="Formulario" active>
                    <b-row>
                        <b-col cols="12" class="py-2">
                            <label for="type">Tipo</label>
                            <b-form-select
                                size="sm"
                                :options="types"
                                id="type"
                                v-model="ticket.type"
                                @change="$v.ticket.type.$touch()"
                                :valid="!$v.ticket.type.$error"
                            ></b-form-select>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="title">Titulo</label>
                            <b-form-input
                                type="text"
                                size="sm"
                                id="title"
                                v-model="ticket.title"
                                @input="$v.ticket.title.$touch()"
                                :valid="!$v.ticket.title.$error"
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="description">Descripción</label>
                            <small
                                >En caso de Error describa paso a paso como
                                surgió y como se puede reproducir</small
                            >
                            <b-form-textarea
                                v-model="ticket.description"
                            ></b-form-textarea>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="reporter"
                                >Usuario que tiene el problema</label
                            >
                            <app-form-select-input
                                :options="users"
                                v-model="ticket.reporter"
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="reporter">Para algun cliente?</label>
                            <app-form-select-input
                                :options="clients"
                                v-model="ticket.clientProblem"
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="module">Módulo de Bitacorapp</label>
                            <app-form-select-input
                                :options="modules"
                                v-model="ticket.moduleId"
                                @change="$v.ticket.moduleId.$touch()"
                                :valid="!$v.ticket.moduleId.$error"
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="device">Dispositivo</label>
                            <b-form-select
                                size="sm"
                                :options="devices"
                                v-model="ticket.device"
                            ></b-form-select>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="images">Imágenes</label>
                            <b-form-file
                                id="image"
                                :options="devices"
                                multiple
                                v-model="images"
                                accept="image/*"
                            ></b-form-file>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Archivos">
                    <b-container fluid class="p-4">
                        <div v-if="photos.length">
                            <b-row>
                                <b-col v-for="p in photos" :key="p.id">
                                    <b-link
                                        width="120"
                                        height="120"
                                        :href="p.file_url"
                                        target="_blank"
                                        >{{ p.name }}</b-link
                                    >
                                    <b-btn
                                        variant="danger"
                                        size="sm"
                                        @click="onDeletePhoto(p.id)"
                                        ><i class="fa fa-trash"></i
                                    ></b-btn>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                            <p>no hay Archivos</p>
                        </div>
                    </b-container>
                </b-tab>
                <b-tab title="Notas" v-if="enableNotes">
                    <b-row>
                        <b-col>
                            <div>
                                <b-form-textarea
                                    id="textarea"
                                    v-model="note"
                                    placeholder="ingrese alguna nota..."
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                            </div>
                        </b-col>
                        <b-col cols="12" md="4" lg="2">
                            <b-button
                                variant="primary"
                                id="btnSendPageTick"
                                class="btn-block"
                                @click="sendNote"
                                >Enviar</b-button
                            >
                        </b-col>
                    </b-row>
                    <br />
                    <b-row>
                        <b-col>
                            <b-row
                                class="mb-2"
                                v-for="(note, i) in ticket.ticketNotes"
                                :key="note.id"
                                :class="{ even: i % 2 === 0, odd: i % 2 !== 0 }"
                            >
                                <b-col>{{ note.user.name }}</b-col>
                                <b-col cols="6">{{ note.note }}</b-col>
                                <b-col>{{ note.created_at | datetime }}</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </div>
    </b-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    data: () => ({
        ticket: {
            id: '',
            title: '',
            description: '',
            reporter: '',
            clientProblem: '',
            device: '',
            moduleId: '',
            type: '',
            globalId: 0,
            ticketNotes: [],
        },
        note: '',
        flagNoteSupport: false,
        enableNotes: false,
        images: [],
        users: [],
        clients: [],
        modules: [],
        photos: [],
        types,
        devices,
        userNote: false,
        names: [],
    }),
    validations: {
        ticket: {
            type: { required },
            title: { required },
            description: { required },
            moduleId: { required },
        },
    },
    methods: {
        async sendNote() {
            if (this.note) {
                const { data } = await repo.post(
                    `tickets/${this.ticket.id}/send-notes`,
                    {
                        note: this.note,
                        flag: this.flagNoteSupport,
                    }
                )
                if (data.status) {
                    toastr.success(data.msg)
                    this.ticket.ticketNotes = data.ticketNoteUser
                    this.userNote = true
                    this.note = ''
                    this.$emit('ticket-saved-note')
                } else {
                    toastr.error(data.msg)
                }
            } else {
                toastr.error('ingrese una nota')
            }
        },
        async onDeletePhoto(id) {
            const { data } = await repo.delete('tickets/deleteImage/' + id)

            if (data.status) {
                this.loadPhotos(this.globalId)
                toastr.success(data.msg)
            } else {
                toastr.error(data.msg)
            }
        },
        fill(ticket) {
            this.note = ''
            if (ticket.ticket_status.slug === 'en-atencion') {
                this.$emit('btn-save-disabled')
            }
            if (ticket.ticket_status.slug === 'solicitado') {
                this.$emit('btn-save-enabled')
            }
            if (ticket.ticket_status.slug === 'en-revision') {
                this.$emit('btn-save-enabled')
            }
            this.enableNotes = true
            this.ticket.type = ticket.error_type
            this.ticket.title = ticket.title
            this.ticket.description = ticket.description
            this.ticket.reporter = ticket.reporter.id
            !!ticket.client && (this.ticket.clientProblem = ticket.client.id)
            this.ticket.moduleId = ticket.module.id
            this.photos = ticket.ticket_files
            this.globalId = ticket.id
            this.ticket.device = !!ticket.device ? ticket.device : ''
            this.ticket.id = ticket.id
            this.ticket.ticketNotes = ticket.ticket_notes
        },
        async loadModules() {
            const { data } = await repo.get('security/modules')
            this.modules = data
        },
        async loadUsers() {
            const { data } = await repo.get('users')
            this.users = data.filter((item) => !item.profile?.client_side)
        },
        async loadClients() {
            const { data } = await repo.get('clients')
            this.clients = data
        },
        async loadPhotos(id) {
            const { data } = await repo.get('tickets/photos/' + id)
            this.photos = data
        },
        reset() {
            Object.keys(this.ticket).map((key) => (this.ticket[key] = ''))
            this.photos = []
            this.images = []
            this.enableNotes = false
        },
        async saveTicket() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return toastr.error(
                    'Los campos: Tipo, Titulo Modulo y Descripcion son obligatorios'
                )
            }
            const formData = new FormData()
            formData.append('type', this.ticket.type)
            formData.append('title', this.ticket.title)
            formData.append('description', this.ticket.description)
            formData.append('reporter', this.ticket.reporter)
            formData.append('clientProblem', this.ticket.clientProblem)
            formData.append('device', this.ticket.device)
            formData.append('module', this.ticket.moduleId)
            formData.append('userId', this.user.id)

            if (!!this.ticket.id) {
                formData.append('_method', 'PUT')
            }

            if (!!this.images.length) {
                this.images.map((item) => formData.append('images[]', item))
            }

            const { data } = !this.ticket.id
                ? await repo.post('tickets/register', formData)
                : await repo.post(`tickets/${this.ticket.id}`, formData)

            if (data.status) {
                toastr.success('Ticket registrado correctamente')
                this.reset()
                !this.ticket.id
                    ? this.$emit('ticket-saved', data.ticket)
                    : this.$emit('ticket-updated', data.ticket)
            } else {
                toastr.error(data.msg)
            }
        },
    },
    mounted() {
        this.loadModules()
        this.loadUsers()
        this.loadClients()
    },
}

const types = [
    {
        value: 'error',
        text: 'Error',
    },
    {
        value: 'solicitud',
        text: 'Solicitud',
    },
    {
        value: 'sugerencia',
        text: 'Sugerencia',
    },
]

const devices = [
    {
        value: 'pc',
        text: 'Computador',
    },
    {
        value: 'tablet',
        text: 'Tablet',
    },
    {
        value: 'celular',
        text: 'Celular',
    },
    {
        value: 'todos',
        text: 'Todos',
    },
]
</script>
